import { createAction } from '../utils';
import * as actionTypes from './stripe.actionTypes';

export const chargeCustomer = (id, amount, description) =>
  createAction(actionTypes.CHARGE_STRIPE_CUSTOMER.REQUEST, {
    id,
    amount,
    description,
  });
